// Initialize InnerImageZoom for all elements with class .iiz-trigger
import InnerImageZoom from 'inner-image-zoom';

export function initInnerImageZoom() {
    const triggers = document.querySelectorAll('.iiz-trigger');
    if (!triggers.length) return;

    triggers.forEach(($el) => {
        new InnerImageZoom('.iiz-trigger', {
            $el,
            zoomScale: 1,
            zoomType: 'click',
        });
    });
}
